export * from '@primeuix/themes/lara/tabview';
export { default } from '@primeuix/themes/lara/tabview';
